import { isEmpty, map } from 'lodash';
import { CONVERSION_STATUS } from 'modules/tracking/config/constants';
import { CONVERSION_DEFAULTS } from 'modules/tracking/config/conversionDefaults';
import { CONVERSION_TYPE } from 'modules/tracking/config/conversionType';

const MAX_EVENT_NAME_LEN = 15;
const isIdOfExistingConversion = id => typeof id == 'number';

const replaceSpacesWithUnderscores = str => str?.replace(/\s+/g, '_') ?? '';

const sanitizeEventName = (category, eventName) => {
    const sanitized = replaceSpacesWithUnderscores(eventName).replace(/[^a-zA-Z0-9_-]/g, '');
    const result = isEmpty(sanitized) ? category : sanitized;
    return result.slice(0, MAX_EVENT_NAME_LEN);
};

export const sanitizeConversionName = (category, conversionName) => {
    if (isEmpty(conversionName)) {
        return category;
    }
    const conversionNameWithSuffix = conversionName + ' (Codeless)';
    return conversionNameWithSuffix.replace(/\s+/g, '_').replace(/\^/g, '');
};

const isURLEvent = type => type === CONVERSION_TYPE.BASIC;

function mapEventName(isExistingConversion, conversionEventName, type, category) {
    if (isExistingConversion) {
        return conversionEventName;
    }
    if (isURLEvent(type)) {
        return null;
    }
    const generateRandomAlphanumeric3Chars = () => Math.random().toString(36).slice(2, 5);
    return sanitizeEventName(category, conversionEventName) + '_tce_' + generateRandomAlphanumeric3Chars();
}

const mapConversionValue = ({
    id: conversionId,
    eventName: existingEventName,
    type,
    includeInTotalConversions,
    category,
    urlEvent,
    conversionName,
    trackedElements,
    status,
}) => {
    const isExisting = isIdOfExistingConversion(conversionId);
    const id = isExisting ? conversionId : undefined;

    if (status === CONVERSION_STATUS.ARCHIVED) {
        return { id, status };
    }

    const sanitizedName = sanitizeConversionName(category, conversionName);
    const eventName = mapEventName(isExisting, existingEventName, type, category);
    const condition = isURLEvent(type) ? buildUrlConditionToGW(urlEvent) : {};

    const base = {
        id,
        type: getConversionType(type),
        condition,
        category,
        includeInTotalConversions,
        eventName,
        conversionName: sanitizedName,
        lookBackWindow: CONVERSION_DEFAULTS.lookBackWindow,
        vtaLookBackWindow: CONVERSION_DEFAULTS.vtaLookBackWindow,
    };

    if (!isURLEvent(type)) {
        base.trackedElements = map(trackedElements, element => ({
            displayText: element.displayText,
            selector: element.selector,
            valueSelector: element.valueSelector,
            href: element.href,
        }));
    }

    return base;
};

const getConversionType = type => {
    if (isURLEvent(type)) {
        return CONVERSION_TYPE.BASIC;
    }
    return CONVERSION_TYPE.EVENT_BASED;
};

const buildUrlConditionToGW = urlEvent => {
    return {
        property: 'URL',
        predicate: 'CONTAINS',
        value: urlEvent,
        children: [],
    };
};

export const saveBulkRulesDTO = newConversions => ({
    elements: map(newConversions, newConversion => ({ value: mapConversionValue(newConversion) })),
});
